<script>
/**
 * Times page - now uses TimesPage component with composition API
 * This file serves as an alias for backward compatibility
 */
import TimesPage from './TimesPage.vue';
export default TimesPage;
</script>
